import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { ApolloClient, ApolloLink, HttpLink } from '@apollo/client';
import { getCache } from '@catalogo/core-graphql-cache';
import hash from 'hash.js/lib/hash/sha/256';
import linkContext from '@catalogo/core-graphql-context';
import { getDevice } from '@catalogo/core-connect/device';
import { fetch } from '@catalogo/core-http';
import { readConfig } from '@catalogo/core-connect/config';
import linkError from './error';
import linkSkin from './skin';
import linkRegion from './region';
import getResolvers from '../../graphql-cache/src/resolvers';

export const getClient = (options, req) => {
  const cache = getCache(req);
  const { config } = readConfig(cache);

  const uri = config.endpoints.graphqlv2;
  const device = getDevice(cache);

  const httpLink = ApolloLink.from([
    linkError(req),
    linkSkin(cache),
    linkRegion(config),
    linkContext(device, req, cache, config),
    new HttpLink({
      uri,
      fetch,
    }),
  ]);

  const link = createPersistedQueryLink({
    useGETForHashedQueries: true,
    disable: () => false,
    sha256: doc => {
      const currentDate = new Date().toJSON().slice(0, 10);
      return hash().update(`${doc}${currentDate}`).digest('hex');
    },
  }).concat(httpLink);

  const errorPolicy = 'all';
  const client = new ApolloClient({
    ...options,
    resolvers: getResolvers(config, cache, device),
    link,
    cache,
    name: 'catalogo-v3',
    defaultOptions: {
      query: {
        errorPolicy,
      },
      watchQuery: {
        errorPolicy,
      },
    },
  });

  if (typeof window !== 'undefined') {
    window.client = client;
  }

  return client;
};
